import { Box, Divider, List } from '@locus-taxy/encore-mui';
import type { SidebarSlotProps } from '@locus-taxy/encore-mui';
import SidebarUserMenu from '../sidebar/SidebarUserMenu';

export default function DashboardSidebarFooter({
  mini,
}: Readonly<SidebarSlotProps>) {
  const sidebarOpen = !mini;

  return (
    <Box
      className="EncoreSidebarFooter-root"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        px: sidebarOpen ? 2 : 1,
        py: 2,
        mt: 'auto',
        position: 'sticky',
        bottom: 0,
        bgcolor: 'background.paper',
        zIndex: 1,
      }}
    >
      <Divider sx={{ borderColor: 'divider' }} />
      <List disablePadding>
        <SidebarUserMenu sidebarOpen={sidebarOpen} />
      </List>
    </Box>
  );
}
